/**
 * Shared CMS origin for viewer modules.
 * Configure via `VITE_CMS_ORIGIN` (e.g. http://192.168.0.10:4100).
 * Do not hardcode machine-specific LAN IPs here.
 */
export const DEFAULT_CMS_ORIGIN = 'http://localhost:3001'

export function getConfiguredCmsOrigin(): string {
  const fromEnv = import.meta.env.VITE_CMS_ORIGIN
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.replace(/\/$/, '')
  }
  return DEFAULT_CMS_ORIGIN
}

export function shouldUseCmsDevProxy(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_CMS_USE_PROXY !== 'false'
}
